import type { Statement } from '@/modules/projects'
import { statementPageUrl } from '@/modules/projects/utils'
import type { ReportCitation } from '../../stores/types'

export interface ResolvedSource {
  label: string
  url: string | null
}

// No matching statement means plain text, the same graceful degradation the rest of the app uses.
export function resolveStatementSource(
  statements: Statement[],
  citation: ReportCitation,
): ResolvedSource | null {
  const fileName = citation.statement_file_name
  if (!fileName) return null

  const page = citation.source_page
  const label = page ? `${fileName} · p.${page}` : fileName
  const statement = statements.find(
    (candidate) => candidate.fileName === fileName,
  )
  if (!statement?.fileUrl) return { label, url: null }

  return { label, url: statementPageUrl(statement.fileUrl, page) }
}
